import { Routes, Route, Navigate } from 'react-router-dom'
import {
  TrafficHubProvider,
  AppStateProvider,
  SigProvider,
  ReactQueryProvider,
} from '@cloudmatize/traffic-hub'
import './App.css'
import { useKeycloak } from '@react-keycloak/web'

import { AppLayout } from './components/AppLayout'
import { TrafficHubPage } from './pages/TrafficHubPage'
import { FavoritesPage } from './pages/FavoritesPage'
import { TrafficLightDetailPage } from './pages/TrafficLightDetailPage'
import { PeriodAnalysisPage } from './pages/PeriodAnalysisPage'
import { TrafficLightSectionDetailPage } from './pages/TrafficLightSectionDetailPage'
import { Toaster } from 'sonner'

function App() {
  const { keycloak } = useKeycloak()
  const token = keycloak?.token
  return (
    <ReactQueryProvider>
      <Toaster position="bottom-center" richColors />

      <TrafficHubProvider language="pt" token={token} apiBaseURL="/api">
        <SigProvider>
          <AppStateProvider initialPage="traffic-hub">
            <Routes>
              <Route element={<AppLayout />}>
                <Route path="/" element={<TrafficHubPage />} />
                <Route path="/map" element={<div className="map-hidden"></div>} />
                <Route path="/favorites" element={<FavoritesPage />} />
                <Route path="/traffic-light-detail" element={<TrafficLightDetailPage />} />
                <Route path="/period-analysis" element={<PeriodAnalysisPage />} />
                <Route
                  path="/traffic-light-section-detail"
                  element={<TrafficLightSectionDetailPage />}
                />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AppStateProvider>
        </SigProvider>
      </TrafficHubProvider>
    </ReactQueryProvider>
  )
}

export default App
